export const tableBgColor = "#fff";
